import React from 'react';

export function SectionCard({
	title,
	value,
	description,
	children
}: {
	title: string;
	value?: string;
	description?: string;
	children?: React.ReactNode;
}) {
	return (
		<div className="rounded-lg border border-gray-200 p-4">
			<p className="mb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-500">{title}</p>
			{value && <p className="mb-1 text-sm font-semibold text-gray-900">{value}</p>}
			{description && <p className="mb-1 text-sm text-gray-700">{description}</p>}
			{children}
		</div>
	);
}
